import { Component, Inject } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { faChevronLeft, faListCheck, faPlusCircle, faXmark } from '@fortawesome/free-solid-svg-icons';
import { ModalService } from '../../../../core/services/modal/modal.service';
import { ProductSetApiService } from '../../../product-set/services/api/product-set-api.service';
import { WebConfigService } from '../../../../core/services/web-config/web-config.service';

@Component({
  selector: 'app-update-tiktok-set-price',
  templateUrl: './update-tiktok-set-price.component.html',
  styleUrl: './update-tiktok-set-price.component.css'
})
export class UpdateTiktokSetPriceComponent {
  faPlusCircle = faPlusCircle;
  faXmark = faXmark;
  faChevronLeft = faChevronLeft
  faListCheck = faListCheck;

  get costPriceIndex() { return this.webConfigService.tiktokCostPriceIndex; }
  get srpPriceIndex() { return this.webConfigService.srpPriceIndex; }
  get percent() { return this.webConfigService.percenTikTokSetList; }

  form: FormGroup;

  keyword = '';
  productsFilter: any[] = [];
  showProductFilter = false;

  constructor(
    private fb: FormBuilder,
    @Inject(MAT_DIALOG_DATA)
    public data: any,
    private ref: MatDialogRef<UpdateTiktokSetPriceComponent>,
    private productSetApiService: ProductSetApiService,
    private modalService: ModalService,
    private webConfigService: WebConfigService,
  ) {
    this.form = this.fb.group({
      products: this.fb.array([], [Validators.required]),
    });
  }

  ngOnInit(): void {
    this.setDefaultProduct(this.data.set_sku)
  }

  async setDefaultProduct(setSku: string) {
    const productSetResponse: any = await this.productSetApiService.getAllTiktokSet({ set_sku: setSku })
    if (!productSetResponse.success && productSetResponse?.data?.length <= 0) {
      return
    }

    const productSetDetials = productSetResponse?.data[0]
    const productDetials = productSetDetials?.product_info || []
    const products = productSetDetials?.products || []
    for (const product of productDetials) {
      if (product.prices) {
        const productMatch = products.find((item: any) => item.sku === product.sku);
        this.selectProduct(product, productMatch.qty, productMatch.srp_price, productMatch.price)
      } else {
        // this.modalService.openModal('fail', 'ไม่พบข้อมูลสินค้าบางรายการ', 'ติดเจ้าหน้าที่เพื่ออัพเดตข้อมูลสินค้าก่อน')
      }
    }
  }

  // Get products form array
  get products(): FormArray {
    return this.form.get('products') as FormArray;
  }

  // Add a selected product to the form
  selectProduct(product: any, defaultQty: number, defaultSrpPrice: number, defaultPrice: number) {
    if (!product.prices) {
      // this.modalService.openModal('fail', 'ไม่พบราคาสินค้า', 'กรุณาอัปเดตราคาสินค้าก่อน');
      return;
    }

    const cost = product.prices[this.costPriceIndex];
    const costAdded = this.addPercentage(cost, this.percent);

    // Add the new product to the form array
    this.products.push(this.fb.group({
      sku: [product.sku],
      name: [product.name],
      qty: [defaultQty, [Validators.required, Validators.min(1)]],
      srp_price: [defaultSrpPrice ?? null, [Validators.required, Validators.min(0)]],
      price: [defaultPrice ?? null, [Validators.required, Validators.min(0)]],
      cost: [cost],
      cost_added: [costAdded]
    }));

    // Clear product search list
    this.productsFilter = this.productsFilter.filter((e: any) => e.sku !== product.sku);
    if (this.productsFilter.length === 0) {
      this.showProductFilter = false;
    }
  }

  // Add percentage to cost
  addPercentage(value: number, percent: number): number {
    return value + (value * (percent / 100));
  }

  // Calculate total quantity
  summaryItem() {
    return parseFloat(this.products.controls.reduce((sum, control) => sum + control.value.qty, 0).toFixed(2));
  }

  // Calculate total SRP
  summarySRP() {
    return parseFloat(this.products.controls.reduce((sum, control) => sum + (control.value.srp_price * control.value.qty), 0).toFixed(2));
  }

  // Calculate total cost added
  summaryCostAdded() {
    return parseFloat(this.products.controls.reduce((sum, control) => sum + (control.value.cost_added * control.value.qty), 0).toFixed(2));
  }

  // Calculate total selling price
  summaryPrice() {
    return parseFloat(this.products.controls.reduce((sum, control) => sum + control.value.price, 0).toFixed(2));
  }

  // Submit the form
  submit() {
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    // Handle form submission
    const formValue: any = this.form.value
    const body = {
      set_sku: this.data.set_sku,
      "products": formValue.products.map((item: any) => ({
        "sku": item.sku,
        "qty": item.qty,
        "price": item.price,
        "cost": item.cost,
        "srp_price": item.srp_price
      })),
      total_price: parseFloat(formValue.products.reduce((sum: number, item: any) => sum + item.price, 0).toFixed(2)),
    }
    this.productSetApiService.updateTiktokSetPrice(body).then((response: any) => {
      if (response.success) {
        this.modalService.openModal('success', 'สำเร็จ', 'ปรับราคาเรียบร้อยแล้ว');
      } else {
        this.modalService.openModal('fail', 'ไม่สำเร็จ', response.message);
      }
      this.cancel()
    })
  }

  // Reset the form
  cancel() {
    this.form.reset();
    while (this.products.length) {
      this.products.removeAt(0);
    }
    this.close()
  }

  close() {
    this.ref.close({ confirm: false });
  }
}
